export const validateNationalInsuranceNumber = (niNumber) => {
  if (!niNumber) {
    return;
  }
  const cleanNI = niNumber.replace(/\s/g, "").toUpperCase();

  if (cleanNI.length !== 9) {
    return "National Insurance Number must be exactly 9 characters long.";
  }
  if (!/^[A-Z]{2}\d{6}[A-Z]$/.test(cleanNI)) {
    return "Must follow format: 2 letters, 6 numbers, 1 letter (e.g., AB123456C).";
  }

  const firstChar = cleanNI[0];
  const secondChar = cleanNI[1];
  const lastChar = cleanNI[8];
  const firstTwoChars = cleanNI.substring(0, 2);

  const invalidChars = ["D", "F", "I", "Q", "U", "V"];
  if (invalidChars.includes(firstChar)) {
    return "First character cannot be D, F, I, Q, U, or V.";
  }
  if (invalidChars.includes(secondChar)) {
    return "Second character cannot be D, F, I, Q, U, or V.";
  }

  if (secondChar === "O") {
    return "Second character cannot be O.";
  }
  const invalidCombinations = ["BG", "GB", "KN", "NK", "NT", "TN", "ZZ"];
  if (invalidCombinations.includes(firstTwoChars)) {
    return `First two characters cannot be ${firstTwoChars}.`;
  }
  if (!["A", "B", "C", "D"].includes(lastChar)) {
    return "Final character must be A, B, C, or D.";
  }

  return "";
};